import { render, staticRenderFns } from "./tellBindDialog.vue?vue&type=template&id=fb8a60e4&scoped=true"
import script from "./tellBindDialog.vue?vue&type=script&lang=js"
export * from "./tellBindDialog.vue?vue&type=script&lang=js"
import style0 from "./tellBindDialog.vue?vue&type=style&index=0&id=fb8a60e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8a60e4",
  null
  
)

export default component.exports